
import React from "react";
import Message from "./Message";
import { Message as MessageType } from "@/types/chat";

interface MessageListProps {
  messages: MessageType[];
  isTransitioning?: boolean;
}

const MessageList: React.FC<MessageListProps> = ({
  messages,
  isTransitioning,
}) => {
  // If there's no messages, return empty div
  if (messages.length === 0) return <div className="space-y-6"></div>;

  // Check if the last message is from the assistant and if it looks like a report
  const lastMessage = messages[messages.length - 1];
  const isLastMessageReport = 
    lastMessage.role === 'assistant' && 
    lastMessage.content.length > 500 &&
    (lastMessage.content.includes("Market Overview") || 
     lastMessage.content.includes("Executive Summary") ||
     lastMessage.content.includes("Competitive Analysis"));
  
  // If the last message is a report, only show that and the query that generated it
  if (isLastMessageReport && messages.length >= 2) {
    // Show the user query that generated the report, and the report itself
    const userQueryIndex = messages.length - 2;
    
    // Make sure the previous message is actually a user query
    if (messages[userQueryIndex].role === 'user') {
      return (
        <div className="space-y-6">
          <Message key="user-query" role={messages[userQueryIndex].role} content={messages[userQueryIndex].content} />
          <Message key="report" role={lastMessage.role} content={lastMessage.content} />
        </div>
      );
    }
  }

  // Otherwise, show all messages
  return (
    <div className="space-y-6">
      {messages.map((message, index) => (
        <Message key={index} role={message.role} content={message.content} />
      ))}
    </div>
  );
};

export default MessageList;
